import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import _toConsumableArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import emojiList from 'static/emoji.json';
export default {
  name: 'im',
  computed: _objectSpread({}, mapGetters(['userInfo'])),
  filters: {
    urlFilter: function urlFilter(url) {
      return require("static/emoji/".concat(url));
    }
  },
  data: function data() {
    return {
      key: '',
      info: {},
      visible: false,
      keyword: '',
      showHistory: false,
      show: false,
      imgSrc: '',
      videoSrc: '',
      audioSrc: '',
      messageContent: '',
      emojiList: emojiList,
      list: [],
      historyList: [],
      historyDefaultList: [],
      currentPage: 1,
      pageSize: 50,
      finish: false,
      ajaxing: false,
      popoverVisible: false
    };
  },
  watch: {
    showHistory: function showHistory(val) {
      if (!val) {
        // this.$refs.historyListBox && this.$refs.historyListBox.removeEventListener('scroll');
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    init: function init(item) {
      this.visible = true;
      this.showHistory = false;
      this.info = item;
      this.socket = this.$store.getters.socket;
    },
    scroll: function scroll(num) {
      var _this2 = this;
      setTimeout(function () {
        _this2.$nextTick(function () {
          var ele = _this2.$refs.chatList;
          if (ele.scrollHeight > ele.clientHeight) {
            //设置滚动条到最底部
            ele.scrollTop = ele.scrollHeight;
          }
        });
      }, num || 0);
    },
    colseIM: function colseIM() {
      this.showHistory = false;
      this.visible = false;
    },
    //处理事件
    handleEvent: function handleEvent(type, src) {
      if (type === 'image') {
        this.imgSrc = src;
        this.show = true;
      } else if (type === 'video') {
        this.videoSrc = src;
        this.show = true;
      } else if (type === 'voice') {
        this.audioSrc = src;
        this.show = true;
      } else if (type === 'file') {
        window.open(src);
      }
    },
    handleClose: function handleClose(done) {
      this.imgSrc = undefined;
      this.videoSrc = undefined;
      this.audioSrc = undefined;
      done();
    },
    getList: function getList(data) {
      var _this3 = this;
      var list = [];
      for (var i = 0; i < data.list.length; i++) {
        var item = data.list[i];
        if (item.contentType === "text") {
          item.content = this.replaceEmoji(item.content);
        } else if (item.contentType === "image") {
          item.content = JSON.parse(item.content);
        } else {
          item.content = JSON.parse(item.content);
        }
        list.push({
          userId: item.sendUserId,
          messageType: item.contentType,
          message: item.content,
          dateTime: this.weforsys.toDate(item.sendTime)
        });
      }
      if (!this.showHistory) {
        this.list = list;
        this.$nextTick(function () {
          _this3.scroll(800);
        });
      } else {
        this.historyList = [].concat(_toConsumableArray(this.historyList), list);
        this.currentPage += 1;
        this.finish = list.length < data.pagination.pageSize;
      }
      this.ajaxing = false;
    },
    addItem: function addItem(item) {
      if (item.messageType === "text") {
        item.message = this.replaceEmoji(item.message);
      } else if (item.messageType === "image") {
        // item.message = JSON.parse(item.message)
      }
      this.list.push(item);
      this.scroll();
      if (this.showHistory) {
        this.historyList.push(item);
      }
    },
    searchHistory: function searchHistory() {
      var _this4 = this;
      this.currentPage = 1;
      this.pageSize = 50;
      this.finish = false;
      this.historyList = [];
      this.sendList();
      this.$nextTick(function () {
        var ele = _this4.$refs.historyListBox;
        ele.scrollTop = 0;
      });
    },
    sendMessage: function sendMessage() {
      if (!this.messageContent) {
        return;
      }
      var socket = this.socket;
      var sendMessage = {
        method: "SendMessage",
        toUserId: this.info.id,
        messageType: "text",
        messageContent: this.messageContent,
        token: this.$store.getters.token
      };
      socket.send(JSON.stringify(sendMessage));
      this.messageContent = '';
    },
    openHistory: function openHistory() {
      var _this5 = this;
      this.showHistory = !this.showHistory;
      if (this.showHistory) {
        this.historyList = [];
        this.currentPage = 1;
        this.pageSize = 50;
        this.finish = false;
        this.sendList();
        this.$nextTick(function () {
          _this5.bindScroll();
        });
      }
    },
    bindScroll: function bindScroll() {
      var _this = this,
        ele = _this.$refs.historyListBox;
      if (!ele) return;
      ele.addEventListener("scroll", function () {
        if (_this.finish || _this.ajaxing) return;
        if (ele.scrollTop >= ele.scrollHeight - ele.clientHeight - 100) _this.sendList();
      });
    },
    sendList: function sendList() {
      this.ajaxing = true;
      var socket = this.socket;
      var messageList = {
        method: "MessageList",
        toUserId: this.info.id,
        formUserId: this.userInfo.userId,
        token: this.$store.getters.token,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        sord: "asc",
        keyword: this.keyword
      };
      socket.send(JSON.stringify(messageList));
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      var _this6 = this;
      if (res.code == 200) {
        if (!res.data || !res.data.name) return;
        var name = res.data.name;
        this.getBase64(file.raw).then(function (res) {
          var data = res;
          _this6.getImgSize(data.e).then(function (res) {
            var messageContent = {
              name: name,
              width: res.width,
              height: res.height
            };
            var sendMessage = {
              method: "SendMessage",
              toUserId: _this6.info.id,
              messageType: "image",
              messageContent: messageContent,
              token: _this6.$store.getters.token
            };
            _this6.socket.send(JSON.stringify(sendMessage));
            _this6.$nextTick(function () {
              _this6.scroll(500);
            });
          });
        });
      } else {
        fileList = [];
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1500
        });
      }
      this.$refs.upload.clearFiles();
    },
    beforeUpload: function beforeUpload(file) {
      var isRightSize = file.size < 1024 * 1024 * 5;
      if (!isRightSize) {
        this.$message.error("\u56FE\u7247\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC75M");
      }
      return isRightSize;
    },
    getBase64: function getBase64(file) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        var msg = {
          base64: '',
          e: null
        };
        reader.readAsDataURL(file);
        reader.onload = function (event) {
          msg.base64 = reader.result.replace(/data:image\/.*;base64,/, '');
          msg.e = event;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(msg);
        };
      });
    },
    getImgSize: function getImgSize(event) {
      return new Promise(function (resolve, reject) {
        var size = {
          width: 0,
          height: 0
        };
        var txt = event.target.result;
        var img = document.createElement("img");
        img.src = txt;
        img.onload = function () {
          size.width = img.width;
          size.height = img.height;
          resolve(size);
        };
        img.onerror = function (error) {
          reject(error);
        };
      });
    },
    replaceEmoji: function replaceEmoji(str) {
      var _this7 = this;
      //替换表情符号为图片
      var replacedStr = str.replace(/\[([^(\]|\[)]*)\]/g, function (item, index) {
        var obj = '';
        for (var i = 0; i < _this7.emojiList.length; i++) {
          var row = _this7.emojiList[i];
          if (row.alt == item) {
            var url = require("static/emoji/".concat(row.url));
            obj = "<img src=\"".concat(url, "\" class=\"chatList-text-emoji\" />");
            break;
          }
        }
        return obj;
      });
      str = replacedStr;
      return str;
    },
    // 选择表情
    selectEmit: function selectEmit(item) {
      this.messageContent += item.alt;
      this.popoverVisible = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    // this.$refs.historyListBox  && this.$refs.historyListBox.removeEventListener('scroll');
  }
};